module.exports = __webpack_public_path__ + "static/media/menu-category.a2349f49.svg";